import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";

ErrorMsg.propTypes = {
  handleCancelClick: PropTypes.func.isRequired,
};

export default function ErrorMsg({ handleCancelClick }) {
  return (
    <Wrapper>
      <Error>
        Oh no! There was a problem loading the details for this recurring gift.
        Please try again, or contact{" "}
        <a href="mailto:help@flocknote.com" target="_blank" rel="noreferrer">
          help@flocknote.com
        </a>{" "}
        for assistance.
      </Error>
      <Buttons>
        <FnrButton onClick={handleCancelClick}>Cancel</FnrButton>
      </Buttons>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const Buttons = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;

const Error = styled.div`
  background-color: #f7f0b6;
  color: #ad8114;
  font-weight: 400;
  padding: 10px 14px;
  border-radius: 10px;
  margin-bottom: 20px;
`;
